const getCustomiseString = (field: any): string => field ?? 'N/A'

export default getCustomiseString
